import React, { useState } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBCard,
  MDBCardBody,
} from "mdbreact";
import Iframe from "react-iframe";
import { toast } from "react-toastify";

import api from "../../../services/api";

import "./styles.css";

export default ({ title, subtitle, message, isVolunteer }) => {
  const [data, setData] = useState({
    subject: "",
    email: "",
    subjectMatter: isVolunteer ? "Serviços voluntários" : "",
    content: isVolunteer ? message : "",
  });

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await api.post("/messages", data);

      if (res.data.success) {
        toast.success("Mensagem enviada com sucesso!");

        setData({
          subject: "",
          email: "",
          subjectMatter: isVolunteer ? "Serviços voluntários" : "",
          content: isVolunteer ? message : "",
        });
      }
    } catch (error) {
      toast.error("Ocorreu um erro!");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact pt-5 pb-3 d-flex align-items-center justify-content-center">
      <MDBContainer>
        <MDBCard>
          <MDBCardBody>
            <MDBRow>
              <MDBCol
                md="6"
                sm="12"
                className="text-center d-flex flex-column aligh-items-center justify-content-center p-md-5"
              >
                <h1 className="title">{title}</h1>
                <h4 className="text-muted mb-5">{subtitle}</h4>
              </MDBCol>

              <MDBCol md="6" sm="12" className="p-3 pr-md-5">
                <form onSubmit={handleSubmit}>
                  <label
                    htmlFor="defaultFormContactNameEx"
                    className="grey-text"
                  >
                    Seu nome*
                  </label>
                  <input
                    type="text"
                    id="defaultFormContactNameEx"
                    className="form-control"
                    requiredvalue={data.subject}
                    onChange={(e) =>
                      setData({ ...data, subject: e.target.value })
                    }
                  />
                  <br />
                  <label
                    htmlFor="defaultFormContactEmailEx"
                    className="grey-text"
                  >
                    Seu email*
                  </label>
                  <input
                    type="email"
                    id="defaultFormContactEmailEx"
                    className="form-control"
                    required
                    value={data.email}
                    onChange={(e) =>
                      setData({ ...data, email: e.target.value })
                    }
                  />
                  <br />
                  {!isVolunteer && (
                    <>
                      <label
                        htmlFor="defaultFormContactSubjectEx"
                        className="grey-text"
                      >
                        Assunto
                      </label>
                      <input
                        type="text"
                        id="defaultFormContactSubjectEx"
                        className="form-control"
                        value={data.subjectMatter}
                        onChange={(e) =>
                          setData({ ...data, subjectMatter: e.target.value })
                        }
                      />
                      <br />
                    </>
                  )}
                  <label
                    htmlFor="defaultFormContactMessageEx"
                    className="grey-text"
                  >
                    Mensagem*
                  </label>
                  <textarea
                    type="text"
                    id="defaultFormContactMessageEx"
                    className="form-control"
                    rows="6"
                    required
                    value={data.content}
                    onChange={(e) =>
                      setData({ ...data, content: e.target.value })
                    }
                  />
                  <div className="text-center mt-4">
                    <MDBBtn
                      color="red"
                      type="submit"
                      disabled={loading}
                      style={{ width: 138, height: 45 }}
                    >
                      {loading ? (
                        <div
                          className="spinner-border spinner-border-sm text-light"
                          role="status"
                        />
                      ) : (
                        <>
                          Enviar
                          <MDBIcon far icon="paper-plane" className="ml-2" />
                        </>
                      )}
                    </MDBBtn>
                  </div>
                </form>
              </MDBCol>
            </MDBRow>
          </MDBCardBody>
        </MDBCard>
      </MDBContainer>

      {!isVolunteer && (
        <div className="mt-5 w-100">
          <Iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3655.691112185895!2d-48.07982138559502!3d-23.615408369474242!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c5cb54548b6e15%3A0x5e6d24fe1268add2!2sR.%20Josepha%20Zaglobynski%20Krapt%2C%20932%20-%20Jardim%20Bela%20Vista%2C%20Itapetininga%20-%20SP%2C%2018207-740!5e0!3m2!1spt-BR!2sbr!4v1592347546650!5m2!1spt-BR!2sbr"
            width="100%"
            height="450"
            frameborder="0"
            style={{ border: 0 }}
            allowfullscreen=""
            aria-hidden="false"
            tabindex="0"
          />
        </div>
      )}
    </div>
  );
};
